var _defs, _rect, _circle, _g, _g2, _g3, _g4, _g5, _path, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInnovation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1996",
    "data-name": "Rettangolo 1996",
    width: 14.962,
    height: 14.893,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8777",
    "data-name": "Tracciato 8777",
    d: "M172.354,954.362a1.03,1.03,0,0,0-.07,1.535l5.038,5.094a1.781,1.781,0,0,0,1.508.464,3.47,3.47,0,0,0,.776-.239.964.964,0,0,0,.189-1.617l-5.455-5.281a1.3,1.3,0,0,0-.907-.309,1.71,1.71,0,0,0-1.078.354",
    transform: "translate(-171.974 -954.008)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.044,
    y1: 0.85,
    x2: -0.043,
    y2: 0.85,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1986",
    "data-name": "Rettangolo 1986",
    width: 14.963,
    height: 14.893,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1985",
    "data-name": "Rettangolo 1985",
    width: 7.331,
    height: 5.177,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8778",
    "data-name": "Tracciato 8778",
    d: "M172.354,954.362a1.66,1.66,0,0,1,1.985-.045l4.967,4.809a3.932,3.932,0,0,1-1.776-.092c-1.122-.426-1.031-1.378-1.995-1.925a3.115,3.115,0,0,0-2.246-.2l-1-1.016a1.03,1.03,0,0,1,.07-1.535",
    transform: "translate(-171.974 -954.008)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.142,
    y1: 1.051,
    x2: -0.14,
    y2: 1.051,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8779",
    "data-name": "Tracciato 8779",
    d: "M1.055,924.99A1.645,1.645,0,0,0,.1,927.111a1.645,1.645,0,0,0,2.087,1.026,1.645,1.645,0,0,0,.953-2.121A1.67,1.67,0,0,0,1.586,924.9a1.563,1.563,0,0,0-.531.093",
    transform: "translate(0 -924.897)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.147,
    y1: 1.767,
    x2: 0.149,
    y2: 1.767,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8780",
    "data-name": "Tracciato 8780",
    d: "M126.19,32.764a4.993,4.993,0,0,0,1.119,3.106l10.152.716L133.632,25.6Z",
    transform: "translate(-126.19 -25.601)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.018,
    y1: 1.18,
    x2: 0.019,
    y2: 1.18,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e38ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#e38ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571f6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1990",
    "data-name": "Rettangolo 1990",
    width: 11.076,
    height: 3.499,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8781",
    "data-name": "Tracciato 8781",
    d: "M158.386,988.519c-1.04-.082-1.816-1.391-2.808-1.081-.745.232-.668,1.121-1.386,1.27s-1.132-.681-1.959-.711a1.363,1.363,0,0,0-.949.369,5.04,5.04,0,0,0,.924,1.765l10.152.716-1.984-3.5c-.815.955-1.468,1.212-1.989,1.171",
    transform: "translate(-151.283 -987.348)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.087,
    y1: 1.135,
    x2: -0.086,
    y2: 1.135,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa80f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165d7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8783",
    "data-name": "Tracciato 8783",
    d: "M789.195,27.542a3.039,3.039,0,0,0-1.273.892,4.3,4.3,0,0,0-.839,1.56,5.926,5.926,0,0,0-.256,1.7c-.007.822,1.041,1.3,1.341,2.134.32.887-.113,2.059.463,2.711a5.871,5.871,0,0,0,1.179,1.028,4.3,4.3,0,0,0,1.641.666,2.963,2.963,0,0,0,2.822-1.017,4.3,4.3,0,0,0,.839-1.56,7.094,7.094,0,0,0-2.728-7.573,4.3,4.3,0,0,0-1.641-.666,3.339,3.339,0,0,0-.551-.047,2.927,2.927,0,0,0-1,.172",
    transform: "translate(-786.828 -27.37)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -0.395,
    y1: 1.201,
    x2: -0.394,
    y2: 1.201,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8784",
    "data-name": "Tracciato 8784",
    d: "M788.429,500.532a2.814,2.814,0,0,0-1.114.748,7.5,7.5,0,0,0,1.6,4.325,2.841,2.841,0,0,0,1.293-.126,2.614,2.614,0,0,0-.79-5.124,2.864,2.864,0,0,0-.992.178",
    transform: "translate(-787.315 -500.354)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -0.872,
    y1: 1.792,
    x2: -0.871,
    y2: 1.792,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8786",
    "data-name": "Tracciato 8786",
    d: "M789.17,27.542a3.039,3.039,0,0,0-1.273.892,4.3,4.3,0,0,0-.839,1.56,7.094,7.094,0,0,0,2.728,7.573,4.3,4.3,0,0,0,1.641.666,2.964,2.964,0,0,0,2.822-1.017,4.3,4.3,0,0,0,.839-1.56,7.094,7.094,0,0,0-2.728-7.573,4.3,4.3,0,0,0-1.641-.666,3.339,3.339,0,0,0-.551-.047,2.927,2.927,0,0,0-1,.172",
    transform: "translate(-786.803 -27.37)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1995",
    "data-name": "Rettangolo 1995",
    width: 2.853,
    height: 3.779,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8785",
    "data-name": "Tracciato 8785",
    d: "M1009.278,544.791c.371,1.029.089,2.053-.62,2.285s-1.547-.4-1.907-1.4-.1-2.016.584-2.272,1.572.359,1.943,1.388",
    transform: "translate(-1006.589 -543.343)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1.389,
    y1: 2.178,
    x2: -1.388,
    y2: 2.178,
    xlinkHref: "#linear-gradient-7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5588",
    "data-name": "Raggruppa 5588",
    transform: "translate(-1222 -167)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2495",
    "data-name": "Rettangolo 2495",
    width: 24,
    height: 24,
    transform: "translate(1222 167)",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_551",
    "data-name": "Ellisse 551",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(1224 169)",
    fill: "#f5f1ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5529",
    "data-name": "Raggruppa 5529",
    transform: "translate(1226.497 171.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4611",
    "data-name": "Raggruppa 4611",
    clipPath: "url(#clip-path)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4581",
    "data-name": "Raggruppa 4581",
    transform: "translate(1.339 7.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4580",
    "data-name": "Raggruppa 4580",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1983",
    "data-name": "Rettangolo 1983",
    width: 10.026,
    height: 10.588,
    transform: "matrix(0.35, -0.937, 0.937, 0.35, -2.597, 6.609)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4588",
    "data-name": "Raggruppa 4588",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4587",
    "data-name": "Raggruppa 4587",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4586",
    "data-name": "Raggruppa 4586",
    transform: "translate(1.339 7.425)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4585",
    "data-name": "Raggruppa 4585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4584",
    "data-name": "Raggruppa 4584",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4583",
    "data-name": "Raggruppa 4583",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4582",
    "data-name": "Raggruppa 4582",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1984",
    "data-name": "Rettangolo 1984",
    width: 7.701,
    height: 8.889,
    transform: "matrix(0.35, -0.937, 0.937, 0.35, -1.909, 4.621)",
    fill: "url(#linear-gradient-2)"
  }))))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4590",
    "data-name": "Raggruppa 4590",
    transform: "translate(0 7.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4589",
    "data-name": "Raggruppa 4589",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1987",
    "data-name": "Rettangolo 1987",
    width: 4.602,
    height: 4.674,
    transform: "translate(-1.372 3.109) rotate(-69.515)",
    fill: "url(#linear-gradient-3)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4592",
    "data-name": "Raggruppa 4592",
    transform: "translate(0.982 0.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4591",
    "data-name": "Raggruppa 4591",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1988",
    "data-name": "Rettangolo 1988",
    width: 13.743,
    height: 13.541,
    transform: "translate(-2.762 0.745) rotate(-15.094)",
    fill: "url(#linear-gradient-4)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4599",
    "data-name": "Raggruppa 4599",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4598",
    "data-name": "Raggruppa 4598",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4597",
    "data-name": "Raggruppa 4597",
    transform: "translate(1.177 7.685)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4596",
    "data-name": "Raggruppa 4596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4595",
    "data-name": "Raggruppa 4595",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4594",
    "data-name": "Raggruppa 4594",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4593",
    "data-name": "Raggruppa 4593",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1989",
    "data-name": "Rettangolo 1989",
    width: 11.449,
    height: 8.766,
    transform: "translate(-1.612 0.713) rotate(-30.058)",
    fill: "url(#linear-gradient-5)"
  }))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8782",
    "data-name": "Tracciato 8782",
    d: "M749.027,7.148c1.088,3.02,3.815,4.8,6.09,3.984s3.238-3.933,2.15-6.953-3.815-4.8-6.09-3.984-3.238,3.933-2.15,6.953",
    transform: "translate(-742.752 0.004)",
    fill: "#d8dee8"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4601",
    "data-name": "Raggruppa 4601",
    transform: "translate(6.124 0.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4600",
    "data-name": "Raggruppa 4600",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1992",
    "data-name": "Rettangolo 1992",
    width: 11.695,
    height: 13.132,
    transform: "matrix(0.949, -0.315, 0.315, 0.949, -3.28, 1.086)",
    fill: "url(#linear-gradient-6)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4603",
    "data-name": "Raggruppa 4603",
    transform: "translate(6.128 3.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4602",
    "data-name": "Raggruppa 4602",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1993",
    "data-name": "Rettangolo 1993",
    width: 6.336,
    height: 6.461,
    transform: "translate(-1.334 0.36) rotate(-15.094)",
    fill: "url(#linear-gradient-7)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4610",
    "data-name": "Raggruppa 4610",
    transform: "translate(6.124 0.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4609",
    "data-name": "Raggruppa 4609",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4608",
    "data-name": "Raggruppa 4608",
    transform: "translate(1.711 4.016)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4607",
    "data-name": "Raggruppa 4607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4606",
    "data-name": "Raggruppa 4606",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4605",
    "data-name": "Raggruppa 4605",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4604",
    "data-name": "Raggruppa 4604",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1994",
    "data-name": "Rettangolo 1994",
    width: 4.904,
    height: 5.234,
    transform: "matrix(0.866, -0.501, 0.501, 0.866, -2.002, 0.843)",
    fill: "url(#linear-gradient-8)"
  })))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/innovation.24daa223d5482684facb5aded677e8cb.svg";
export { ForwardRef as ReactComponent };